<section class="new-translation" fxLayout fxLayoutAlign="center">
  <form #f="ngForm" (ngSubmit)="onSubmit(f)">
    <mat-card fxFlex.xs="100%" fxFlex="600px">
      <mat-card-title fxLayoutAlign="center" *ngIf="translationService.translationData.translationId"> Edit Translation</mat-card-title>
      <mat-card-title fxLayoutAlign="center" *ngIf="!translationService.translationData.translationId"> Create Translation</mat-card-title>
      <mat-card-content fxLayout="column">
        <mat-form-field>
          <mat-select placeholder="Translation Type ID" [formControl]="translationTypeControl" [(ngModel)]="translationService.translationData.translationTypeId" required>
            <mat-option>--</mat-option>
            <mat-option *ngFor="let t of translationtypes" [value]="t.translationTypeId">
              {{t.translationTypeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <input type="text" matInput placeholder="Original" [(ngModel)]="translationService.translationData.original" name="original" required
                 #Original="ngModel" />
          <mat-error *ngIf="Original.hasError('required')">Original cannot be empty</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input type="text" matInput placeholder="Translated" [(ngModel)]="translationService.translationData.translated" name="translated"
                 #Translated="ngModel" />

        </mat-form-field>
       
          <mat-checkbox [(ngModel)]="translationService.translationData.ignore" name ="ignore" #Ignore="ngModel"></mat-checkbox>
       
      </mat-card-content>
      <mat-card-actions fxLayoutAlign="center">
        <button type="submit" [disabled]="translationTypeControl.hasError('required')" mat-raised-button color="primary">Submit</button>
        <button type="button" mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
      </mat-card-actions>
    </mat-card>
  </form>
</section>

